import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  customButtonWrapper: {
    width: 'auto'
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  filterContainer: {
    '& .containerButtons': {
      display: 'flex',
      gap: '20px',
      marginBottom: '20px'
    }
  },

  buttonWrapper: {
    width: 'max-content',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: '8px',

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  salesContainer: {
    padding: '16px  0',
    display: 'flex',
    flexDirection: 'column'
  },

  salesHeaderContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start'
    }
  },

  salesHeaderBtnContainer: {
    display: 'flex',
    alignItems: 'center',

    '& :nth-child(2)': {
      width: 139,
      marginLeft: 16
    },

    [theme.breakpoints.down('sm')]: {
      padding: '16px 0',
      flexWrap: 'wrap'
    }
  },

  salesContainerContent: {
    width: '100%',
    overflow: 'hidden',
    display: 'flex',

    '&>*:nth-child(2)': {
      marginRight: 24,
      marginLeft: 24
    },

    '@media (max-width:767px)': {
      overflowX: 'scroll'
    }
  },

  salesStatusPending: {
    padding: 10,
    backgroundColor: '#5778EC',
    borderRadius: 4,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  salesStatusDone: {
    maxWidth: 91,
    padding: 10,
    backgroundColor: '#4BC599',
    borderRadius: 4,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  salesStatusText: {
    width: 110,
    color: '#fff'
  },

  salesContainerContentData: {
    height: '100%',
    position: 'relative',
    paddingRight: 16
  },

  salesDivider: {
    width: 'calc(100% - 293px)',

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  salesTableActions: {
    width: '100%',
    display: 'flex',
    height: 5,
    '& img': {
      cursor: 'pointer'
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-around'
    }
  },
  salesHeader: {
    display: 'block',
    width: '100%',
    alignItems: 'center',
    // paddingRight: 16,
    '@media (min-width:356px)': {
      // paddingRight: 16,
      display: 'inline-flex'
    }
  },

  salesTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    fontWeight: theme.app.typography.subTitle.fontWeight
  },

  salesSubTitle: {
    color: theme.palette.primary.main,
    fontSize: 18,
    fontWeight: 500
  },
  salesDividerSubTitle: {
    height: 1,
    width: '100%',
    backgroundColor: '#E5E5E5'
  },

  buttonContainer: {
    display: 'flex',
    gap: '10px',
    marginBottom: '-2px',
    paddingLeft: '10px',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
      marginTop: '8px',
      flexDirection: 'column',
      width: '100%'
    }
  },

  propertiesTableActions: {
    width: '100%',
    display: 'flex',
    height: 5,
    '& img': {
      cursor: 'pointer'
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-around'
    }
  },
  salesPopup: {
    '& .popup__box': {
      height: 'unset !important',
      maxWidth: 845
    }
  }
}))
